<ng-template #confirmDialogTemplate let-dialog="dialog" let-message="message">
  <div class="confirm-dialog-container">
    <div class="header-text">{{ message?.header }}</div>
    <div>{{ message?.message }}</div>

    <div class="confirm-dialog-footer">
      <jenz-button
        type="primary"
        [label]="message?.acceptLabel"
        (onClick)="dialog.accept()"
        (onClick)="dialog.hide(2)"
      ></jenz-button>

      @if (message?.rejectLabel) {
        <jenz-button
          type="secondary"
          [label]="message?.rejectLabel"
          (onClick)="dialog.reject()"
          (onClick)="dialog.hide(2)"
        ></jenz-button>
      }
      @if (dialog.key !== 'no-cancel') {
        <jenz-button
          type="transparent"
          label="general.cancel"
          (onClick)="dialog.hide(2)"
        ></jenz-button>
      }
    </div>
  </div>
</ng-template>

<p-confirmDialog #confirmDialog class="confirm-dialog" [closeOnEscape]="false">
  <ng-template pTemplate="headless" let-message>
    <ng-container
      *ngTemplateOutlet="
        confirmDialogTemplate;
        context: { dialog: confirmDialog, message: message }
      "
    ></ng-container>
  </ng-template>
</p-confirmDialog>

<p-confirmDialog
  #noCancelConfirmDialog
  class="confirm-dialog"
  key="no-cancel"
  [closeOnEscape]="false"
>
  <ng-template pTemplate="headless" let-message>
    <ng-container
      *ngTemplateOutlet="
        confirmDialogTemplate;
        context: { dialog: noCancelConfirmDialog, message: message }
      "
    ></ng-container>
  </ng-template>
</p-confirmDialog>
